import Styled from 'styled-components'

export default Styled.div`
  background: ${props => props.theme.colors.white};
  border: 1px solid ${props => props.theme.colors.gray.shade100};
  border-radius: ${props => props.theme.radius};
  box-shadow: 0 5px 5px -5px rgba(0, 0, 0, 0.1);
  padding: 2rem;
  width: 26rem;
  max-width: calc(100% - 4rem);
`



// WEBPACK FOOTER //
// ./src/components/AuthBox/index.js